<template>
  <div>
    <div v-if="rule.options.length <= 3">
      <div class="flex flex-wrap">
        <button
          class="btn text-sm mr-1 focus:outline-none flex-1"
          :class="value === option.value ? option.class : 'bg-theme-300 border border-theme-200 light:border-theme-800 light:bg-theme-600'"
          v-for="(option, i) in rule.options"
          :key="'filter-options-' + rule.name + '-' + i"
          @click="$emit('input', value === option.value ? rule.default : option.value)"
        >
          {{ option.name || option.value | sentenceCase }}
        </button>
      </div>
    </div>

    <div class="flex flex-wrap flex-col" v-else>
      <div class="flex flex-wrap items-center -mx-1">
        <div class="relative flex-grow px-1">
          <select
            class="form-control pr-8"
            :value.sync="value"
            @change="$emit('input', $event.target.value)"
          >
            <option></option>
            <option
              v-for="(option, i) in rule.options"
              :value="option.value"
              :key="rule.name + '-options-' + i"
            >{{ option.name || option.value | sentenceCase }}</option>
          </select>
          <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center text-xs px-2">
            <i class="fas fa-chevron-down"></i>
          </div>
        </div>
        <div
          class="text-xs px-2 btn btn-red px-1 w-8 h-10 flex items-center justify-center"
          @click="$emit('input', rule.default)"
        >
          <i class="fas fa-times"></i>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    rule: {},
    value: {},
  },
}
</script>
